<template>
    <div class="upload-single-image d-flex flex-column h-100">
        <div class="row" v-if="label">
            <div class="col">
                <h6 class="font-weight-normal">{{label}}</h6>
                <hr class="mt-2" />
            </div>
        </div>
        <div class="row h-100">
            <div class="col-12">
                <div class="h-100">
                    <UploadMultipleImage
                        :disabled="disabled"
                        :ref="name"
                        v-model="images"
                        :maxImage="1"
                        :multiple="false"
                        :noOverlay="true"
                        :name="name"
                        :showImageLimitMessage="false"
                        :imageClass="imageClass"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isAbsoluteURL, isString} from '@config/utils';

export default {
    name: 'UploadSingleImage',
    components: {
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ '@/components/form/UploadMultipleImage.vue'),
    },
    props: {
        value: {
            type: [Object, String],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            require: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        imageClass: {
            type: String,
            default: 'background-cover'
        },
    },
    data() {
        return {
            images: [],
        }
    },
    methods: {
        getFormatUrlAPI(path) {
            return this.$root.$helper.global.formatUrlAPI(path);
        },
        changeValue(value) {
            if(isString(value)) {
                this.images = value ? [{path: isAbsoluteURL(value) ? value : this.getFormatUrlAPI(value)}] : [];
            }
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue, oldValue) {
                this.changeValue(newValue);
            },
        },
        images: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit('input', newValue.length ? newValue[0] : null);
            },
        },
    },
}
</script>